import React, { FC } from 'react';
import { Wrapper, ErrorInfo } from './styles';
import { ReactComponent as NoInternetIcon } from 'applicaiton/assets/no_internet.svg';
import { useTranslation } from 'react-i18next';

import { Props } from './models';

const NoInternetPage: FC<Props> = ({ online }) => {
  const { t } = useTranslation();

  return (
    <Wrapper online={online}>
      <ErrorInfo>
        <NoInternetIcon />
        <h2>{t('no_internet.sorry')}</h2>
        <h4>{t('no_internet.description')}</h4>
        <p>{t('no_internet.try_again')}</p>
      </ErrorInfo>
    </Wrapper>
  );
};

export default NoInternetPage;
